import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  // Confirmed, and NOT what the title rule derives. The reference screenshots
  // for this book's page came from
  // `digitopia.co/impact-labs/ebooks/sustainability-innovation/` on
  // 2026-08-28, so the address is the short one and
  // `leading-the-charge-in-sustainability-innovation` was a wrong guess — the
  // third slug anybody has been able to check, and the first the rule got
  // wrong.
  'sustainability-innovation',
  'Leading the Charge in Sustainability Innovation',
  `${UPLOADS}/2024/09/digitopia-sustainability-innovation-cover-400x400.jpg`,
  {
    confirmed: true,
    download: pdf(
      '56756e66-41c8-4a3b-ba4a-12eeec5604ec-Leading the Charge in Sustainability Innovation.pdf',
    ),
    // Designed as its own written page on 2026-08-28, the third after
    // Transform Better and Agentic AI — so the card goes there and
    // `prerender.tsx` skips it, rather than generating this template over the
    // top of it.
    href: '/en/impact-labs/ebooks/sustainability-innovation',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 10
